export default Object.freeze({
  Localization: '1',
  Morphology: '2',
  IHC: '3',
});
